// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2ATHd","label":"LabeledBox_label__2lKnh"};